import { fork, all } from 'redux-saga/effects';
import * as mainSagas from './index';

export default function* rootSaga() {
  yield all([...Object.values(mainSagas).map(fork)]);
}
